module.exports = __webpack_public_path__ + "img/关闭.2e8551b8.png";